import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Spin, Col, Row } from 'antd';
import Translate from 'react-translate-component';

import { filterDefaultSettings } from 'helpers/settingsHelpers';
import ErrorHTML from 'components/common/form/ErrorHTML';
import SettingsForm from './SettingsForm';

export default class SettingsModal extends Component {
    static propTypes = {
        modal: PropTypes.object.isRequired,
        close: PropTypes.func.isRequired,
        getSettings: PropTypes.object.isRequired,
        postSettings: PropTypes.object.isRequired,
        defaultSettings: PropTypes.object.isRequired,
        translatePrefix: PropTypes.string.isRequired,
        translateHeader: PropTypes.string,
    }

    componentDidUpdate(prevProps) {
        const { close, postSettings: { meta } } = this.props;
        const { success } = prevProps.postSettings.meta;

        if (!success && meta.success) {
            close();
        }
    }

    saveSettings = () => {
        this.props.postSettings.dispatch(this.form.state);
    }

    setDefault = () => {
        const { defaultSettings } = this.props;
        const settings = filterDefaultSettings(defaultSettings);

        this.form.setState({
            fields: settings.fields,
            stringHeight: settings.stringHeight,
            locked: settings.locked
        });
    }

    renderFooter = (meta) => (
        <Row>
            <Col xs={{ span: 12 }} className="alert-inline">
                <ErrorHTML meta={meta} />
            </Col>
            <Col xs={{ span: 12 }}>
                <Button loading={meta.pending} onClick={this.setDefault}>
                    <Translate content="modal_settings.default" />
                </Button>
                <Button loading={meta.pending} type="blue" onClick={this.saveSettings}>
                    <Translate content="modal_settings.save"/>
                </Button>
            </Col>
        </Row>
    );

    render() {
        const { modal, translatePrefix, translateHeader, getSettings: { data }, postSettings : { meta } } = this.props;

        const title = <Translate content={translateHeader || `${translatePrefix}settingsTitle`} />;
        const footer = this.renderFooter(meta);

        return (
            <Modal {...modal} title={title} footer={footer} className="modal-normal">
                <Spin spinning={meta.pending}>
                    <div className="settings-form">
                        <SettingsForm
                            ref={node => this.form = node}
                            settings={data}
                            translatePrefix={translatePrefix}
                        />
                    </div>
                </Spin>
            </Modal>
        );
    }
}
